// extracted by mini-css-extract-plugin
export default {"content":"PhoneAdd_content__TVUFz","list":"PhoneAdd_list__n3iji","contacts":"PhoneAdd_contacts__jOeGR"};